'use client';
import React, { useMemo } from 'react';
import { createRoot } from 'react-dom/client';
import TextType from '../texttype/TextType';
import './login.css';

const DEFAULT_LOGIN_TAGLINES = [
  'Calendar, tasks, and chat at a glance.',
  'Smart reminders keep your team in flow.',
  'Dashboard, command palette, and Pixelblast for creative breaks.',
  'Secure shares make collaboration spontaneous.',
  'From scheduling to push notifications - everything in Keule.',
];

const sanitizeTextList = (value, fallback) => {
  if (!Array.isArray(value)) {
    return fallback;
  }
  const normalized = value
    .map((entry) => (typeof entry === 'string' ? entry.trim() : ''))
    .filter((entry) => entry.length > 0);
  return normalized.length > 0 ? normalized : fallback;
};

const getLoginTaglines = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LOGIN_TAGLINES;
  }
  const fallback = sanitizeTextList(window.__loginHeaderFallbackTexts, DEFAULT_LOGIN_TAGLINES);
  return sanitizeTextList(window.__textTypeLoginTexts, fallback);
};

const LOGIN_TAGLINES = getLoginTaglines();

const LoginHeaderTextType = () => {
  const textColors = useMemo(
    () => [
      'var(--color-text-primary, #f5f7fa)',
      'var(--accent, #8bc6ff)',
      'var(--color-text-primary, #f5f7fa)',
      'var(--accent-muted, #a9cffe)',
    ],
    [],
  );

  return (
    <TextType
      as="p"
      text={LOGIN_TAGLINES}
      typingSpeed={70}
      pauseDuration={2000}
      deletingSpeed={35}
      variableSpeed={{ min: 45, max: 95 }}
      showCursor
      cursorCharacter="|"
      className="login-texttype"
      textColors={textColors}
      aria-live="polite"
    />
  );
};

const mountLoginHeader = () => {
  const container = document.getElementById('login-texttype-root');
  if (!container) {
    return;
  }

  const root = createRoot(container);
  root.render(<LoginHeaderTextType />);

  window.addEventListener(
    'beforeunload',
    () => {
      root.unmount();
    },
    { once: true },
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountLoginHeader, { once: true });
} else {
  mountLoginHeader();
}
